import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@dashboard/lib/utils';

interface Props {
  /** Override the default `size-4 animate-spin` styling. Pass e.g.
   *  `size-3.5` for inline buttons or `size-5 text-muted-foreground`
   *  for full-cell overlays — `cn` merges and twMerge resolves the
   *  conflicting size classes. */
  className?: string;
}

/**
 * Canonical spinning loader icon. Wraps lucide's `Loader2` with the
 * standard `animate-spin` class and a sensible default size so callers
 * don't keep re-typing `<Loader2 className="size-X animate-spin" />`.
 *
 * Use this for inline loading affordances on buttons / table cells /
 * iframe overlays. The legacy SVG `@dashboard/components/Spinner` is a
 * separate component with a different visual; it's still in use across
 * older surfaces but new code should reach for `LoaderIcon`.
 */
export function LoaderIcon({ className }: Props) {
  return <Loader2 className={cn('size-4 animate-spin', className)} />;
}
